import React, { useState } from "react";
import ReactSelect from "react-select";
import { InputError } from "../../../components/error/error";
import {
  DatePicker,
  PrimaryButton,
  PrimaryCancelButton,
  RadioButton,
} from "../../../components/micro/input";
import ReactDatePicker from "react-datepicker";

const SchedulingModal = ({ mode }) => {
  const [selectedType, setSelectedType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("existingQuotation");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  const [error, setError] = useState("");

  return (
    <>
      <div className="model">
        <div className="flex flex-col items-center justify-center">
          <div className="bg-white drop-shadow-lg rounded-lg w-[600px] py-8 px-6 mx-auto relative">
            <div className="flex justify-center">
              <h2 className="text-3xl font-normal font-Montserrat text-center mb-6 ">
                {mode === "schedule"
                  ? "Scheduling"
                  : "ReSchedule service appointment"}
              </h2>
            </div>
            {mode === "schedule" ? (
              <div>
                <div className="pt-5">
                  <ReactSelect
                    className={"w-full text-black p-0 font-Proxima"}
                    id="outlet"
                    placeholder="Outlet"
                    isClearable={true}
                    value={selectedType}
                    onChange={(e) => {
                      setError("");
                      setSelectedType(e);
                    }}
                    styles={{
                      control: (base) => ({
                        ...base,
                        border: `1px solid #0000003B`,
                        borderColor: selectedType ? "#F15B29" : "#0000003B",
                        borderRadius: "0.3rem",
                        boxShadow: "none",
                        "&:hover": {
                          border: "1px solid #0000003B",
                        },
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected ? "#F15B29" : "white",
                        "&:active": {
                          backgroundColor: state.isSelected
                            ? "#F15B29"
                            : "rgba(0, 0, 0, 0.04)",
                        },
                      }),
                    }}
                  />
                  {error && <InputError errorTitle={error} />}
                </div>
                <div className="pt-5 pb-5">
                  <ReactSelect
                    className={"w-full text-black p-0 font-Proxima"}
                    id="technician"
                    placeholder="Technician"
                    isClearable={true}
                    value={selectedType}
                    onChange={(e) => {
                      setError("");
                      setSelectedType(e);
                    }}
                    styles={{
                      control: (base) => ({
                        ...base,
                        border: `1px solid #0000003B`,
                        borderColor: selectedType ? "#F15B29" : "#0000003B",
                        borderRadius: "0.3rem",
                        boxShadow: "none",
                        "&:hover": {
                          border: "1px solid #0000003B",
                        },
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected ? "#F15B29" : "white",
                        "&:active": {
                          backgroundColor: state.isSelected
                            ? "#F15B29"
                            : "rgba(0, 0, 0, 0.04)",
                        },
                      }),
                    }}
                  />
                  {error && <InputError errorTitle={error} />}
                </div>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <RadioButton
                      idFrom="new"
                      name="quotation"
                      label="Push to Technician Listing"
                      className="text-base text-left font-normal font-Proxima"
                      onChange={() => setSelectedOption("newQuotation")}
                    />
                  </div>
                  <div className="flex items-center">
                    <RadioButton
                      idFrom="existingQuotation"
                      name="quotation"
                      label="Manual Arrangement"
                      className="text-base font-normal font-Proxima"
                      defaultChecked
                      onChange={() => setSelectedOption("existingQuotation")}
                    />
                  </div>
                  {selectedOption === "existingQuotation" && (
                    <>
                      <div className="plus-number-inputs rounded w-full px-3 py-1.5  transition duration-300 ease-in-out border border-borderTheme">
                        <ReactDatePicker
                          selected={selectedDate}
                          onChange={(date) => setSelectedDate(date)}
                          selectsStart
                          maxDate={new Date()}
                          id="dob"
                          dateFormat="dd/MM/yyyy"
                          placeholderText={"Appointment Date"}
                          className="w-full"
                        />
                        <DatePicker
                          id="appointmentDate"
                          value={selectedDate}
                          onChange={(date) => setSelectedDate(date)}
                          format="DD/MM/YYYY"
                          icon={null}
                        />
                        {error && <InputError errorTitle={error} />}
                      </div>
                      <div className="plus-number-inputs rounded w-full px-3 py-1.5  transition duration-300 ease-in-out border border-borderTheme">
                        <ReactDatePicker
                          selected={selectedTime}
                          onChange={(time) => setSelectedTime(time)}
                          showTimeSelect
                          showTimeSelectOnly
                          timeFormat="HH:mm: aa"
                          timeIntervals={30}
                          placeholderText={"Appointment Time"}
                          dateFormat="HH:mm: aa"
                        />

                        {error && <InputError errorTitle={error} />}
                      </div>
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div>
                <div className="text-gray-light font-normal">
                  <p>Outlet: Outlet Name 1</p>
                  <p>Original Date: dd/mm/yyyy</p>
                  <p>Original Time Range: HH/MM - HH/MM</p>
                </div>
                <div className="plus-number-inputs rounded w-full px-3 py-1.5  transition duration-300 ease-in-out border border-borderTheme my-4">
                  <ReactDatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    selectsStart
                    maxDate={new Date()}
                    id="dob"
                    dateFormat="dd/MM/yyyy"
                    placeholderText={"New Date"}
                    className="w-full"
                  />
                  {error && <InputError errorTitle={error} />}
                </div>
                <div className="plus-number-inputs rounded w-full px-3 py-1.5  transition duration-300 ease-in-out border border-borderTheme">
                  <ReactDatePicker
                    selected={selectedTime}
                    onChange={(time) => setSelectedTime(time)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeFormat="HH:mm: aa"
                    timeIntervals={30}
                    placeholderText={"New Timing"}
                    dateFormat="HH:mm: aa"
                  />

                  {error && <InputError errorTitle={error} />}
                </div>
              </div>
            )}
            <div className="flex justify-center gap-3 pt-7">
              <PrimaryCancelButton
                value={"Cancel"}
                // onClick={handleCancelClick}
              />
              <PrimaryButton
                value={"Confirm"}
                disabled={isLoading}
                // onClick={handleAddClick}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SchedulingModal;
